import React from 'react';
import { IconProps } from '.';

const SvgCommentAlert = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M15 19h7V3H2v16h7l3 4 3-4Zm-3 1.5 2.25-3h6.25v-13h-17v13h6.25l2.25 3Z'
        clipRule='evenodd'
      />
      <path fill={color} fillRule='evenodd' d='M13 13.75H7v-1.5h6v1.5ZM17 9.75H7v-1.5h10v1.5Z' clipRule='evenodd' />
      <path
        fill='#4769F7'
        fillRule='evenodd'
        d='M18 0c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6Z'
        clipRule='evenodd'
      />
      <path fill='#fff' fillRule='evenodd' d='M17.25 7V2h1.5v5h-1.5ZM17.25 10V8.5h1.5V10h-1.5Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgCommentAlert;
